import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_PEDIDO_EGRESO_CALADO } from '../../../../config/forms'
import { ToastContainer, toast } from 'react-toastify'
import TablaPedidosDeBrutoACalado from '../../containers/pedidoCamionesEnCalado/TablaPedidosDeBrutoACalado'
import { obtenerCallesDeBruto, setShowFooterPesado, cargarPedidoDeBruto } from '../../actions'
import { getDataCamionesCalados } from '../../../Calado/actions'
import CamposPedidoCamiones from './CamposPedidoCamiones'
import GraficoCallesButo from './GraficoCallesBruto'
import { Row, Col } from 'react-bootstrap'
import { Button } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'

function PedidosEgresoCalado (props) {
  const { setShowFooterPesado, obtenerCallesDeBruto, camionesCalados, cargarPedidoDeBruto, getDataCamionesCalados, change: formChange, roles } = props
  const [cerealesActivos, setCerealesActivos] = useState([])
  const [calificaciones, setCalificaciones] = useState([])
  const [disponible, setDisponible] = useState(null)
  const [crearPedido, setCrearPedido] = useState(false)
  const [rolAutorizado, setRolAutorizado] = useState(false)

  useEffect(() => {
    setShowFooterPesado()
    obtenerCallesDeBruto()
    getDataCamionesCalados()
  }, [setShowFooterPesado, obtenerCallesDeBruto, getDataCamionesCalados])

  useEffect(() => {
    const cereales = []
    const calificacionesActivas = []
    camionesCalados && camionesCalados.map(cc => {
      const isAutorizado = cc.estadoAutorizacion === 'Autorizado'
      const isSiloAparte = cc.caravana === false
      const pedidosDelCereal = props.camionesPedidosBruto.filter(p => p.cereal.trim() === cc.claveCereal.trim())
      let cantidadPedidos = 0
      pedidosDelCereal.map((p) => {
        cantidadPedidos += p.cantidad
      })

      const existe = cereales.find(c => c.fieldName === cc.claveCereal.trim())
      if (!existe) {
        cereales.push({
          fieldName: cc.claveCereal.trim(),
          name: cc.claveCereal.trim(),
          label: cc.cereal,
          cantidad: 1,
          autorizados: isAutorizado ? 1 : 0,
          cantidadSiloAparte: isSiloAparte ? 1 : 0,
          cantidadSiloAparteAutorizado: (isSiloAparte && isAutorizado) ? 1 : 0,
          pedidosRealizados: cantidadPedidos

        })
      } else {
        existe.cantidad += 1
        if (isAutorizado && isSiloAparte) {
          existe.cantidadSiloAparteAutorizado += 1
        } else if (isAutorizado) {
          existe.autorizados += 1
        }
        if (isSiloAparte) {
          existe.cantidadSiloAparte += 1
        }
      }

      const existeCondicion = calificacionesActivas.find(ca => ca.fieldName === cc.claveCalificacionCereal)
      if (!existeCondicion) {
        const pendientes = props.camionesPedidosBruto.filter(p => p.cereal === cc.claveCereal.trim() && !p.caravana)
        let totalPendientes = 0
        pendientes && pendientes.map(p => {
          totalPendientes += p.cantidad
          return totalPendientes
        })

        const pendientesSiloAparte = props.camionesPedidosBruto.filter(p => p.caravana && p.cereal === cc.claveCereal.trim())
        let totalPendientesSiloAparte = 0
        pendientesSiloAparte && pendientesSiloAparte.map(p => {
          totalPendientesSiloAparte += p.cantidad
          return totalPendientesSiloAparte
        })

        calificacionesActivas.push({
          fieldName: cc.claveCalificacionCereal,
          name: cc.calificacionCereal,
          label: cc.calificacionCereal,
          cantidad: 1,
          cantidadAutorizada: isAutorizado ? 1 : 0,
          cantidadAutorizadaSiloAparte: (isSiloAparte && isAutorizado) ? 1 : 0,
          cantidadSiloAparte: isSiloAparte ? 1 : 0,
          cereal: cc.claveCereal.trim(),
          pedidosPendientes: totalPendientes,
          pedidosPendientesSiloAparte: totalPendientesSiloAparte
        })
      } else {
        existeCondicion.cantidad += 1
        if (isAutorizado) {
          existeCondicion.cantidadAutorizada += 1
        }
      }
      return { cereales, calificacionesActivas }
    })

    setCerealesActivos(cereales)
    setCalificaciones(calificacionesActivas)
  }, [camionesCalados, props.camionesPedidosBruto])

  useEffect(() => {
    if (props.calleDeBruto) {
      const dataCalle = props.callesDeBruto.find((c) => c.nombreCorto.trim() === props.calleDeBruto)
      const capacidad = dataCalle.capacidad
      const ocupado = (props.ocupacionBruto && props.ocupacionBruto[props.calleDeBruto].camiones.length) || null
      const disponible = (capacidad - ocupado) || null
      const pedidosPendientes = props.camionesPedidosBruto.filter(p => p.calleDeBruto.trim() === props.calleDeBruto)
      let pendientes = 0

      if (pedidosPendientes.length > 0) {
        pedidosPendientes.map((pp) => {
          pendientes += pp.pendientes
          return pendientes
        })
      }
      setDisponible(disponible - pendientes)
    }
  }, [
    props.calleDeBruto,
    props.callesDeBruto,
    props.ocupacionBruto,
    setDisponible,
    props.camionesPedidosBruto
  ])

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'BALANCEROCAMIONES' || roles === 'DESARROLLADOR')
    setRolAutorizado(rol.length > 0)
  }, [roles])

  const actualizarDatos = () => {
    obtenerCallesDeBruto()
    getDataCamionesCalados()
  }

  const handleSubmit = () => {
    const { calleDeBruto, cereal, cantidad } = props
    if (calleDeBruto) {
      if (cereal) {
        if (cantidad && cantidad > 0) {
          cargarPedidoDeBruto()
          setCrearPedido(false)
          actualizarDatos()
        } else {
          toast.error('Debe indicar la cantidad de camiones.')
        }
      } else {
        toast.error('Debe seleccionar el cereal.')
      }
    } else {
      toast.error('Debe seleccionar una calle de bruto')
    }
  }

  const cleanCalificacion = () => {
    formChange('calificacionCereal', null)
  }

  const saveDataCamionesGrafico = (camiones) => {
    formChange('ocupacionBruto', camiones)
  }

  return (
    <>
      <ToastContainer />
      <h2 style={{ margin: '2% auto', textAlign: 'center' }} >
        Pedidos de camiones para bruto
      </h2>
      <Row style={{ width: '98%' }}>
        <Col
          md={9}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'flex-start',
            margin: '0 auto'
          }}
        >
          {crearPedido && <CamposPedidoCamiones
            cerealesActivos={cerealesActivos}
            calificaciones={calificaciones}
            handleSubmit={handleSubmit}
            cleanCalificacion={cleanCalificacion}
            callesDeBruto={props.callesDeBruto}
            max={disponible}
            formChange={props.change}
          />
          }
          {!crearPedido && rolAutorizado &&
            <Button
              variant='contained'
              style={{ backgroundColor: COLORES.violet, color: 'white', margin: '0 6%' }}
              onClick={() => { setCrearPedido(true) }}
            >
                    Generar nuevo pedido
            </Button>
          }

          <div className='tabla-pedidos-calado'>
            <TablaPedidosDeBrutoACalado />
          </div>
        </Col>
        <Col md={3}>
          {props.receiveCamListosParaBruto &&
            <GraficoCallesButo
              camListosParaBruto={props.camListosParaBruto}
              callesDeBruto={props.callesDeBruto}
              saveCamiones={saveDataCamionesGrafico}
            />
          }
        </Col>
      </Row>
    </>
  )
}

const selector = formValueSelector(FORM_PEDIDO_EGRESO_CALADO)
const mapStateToProps = (state) => ({
  calificacionCereal: selector(state, 'calificacionCereal'),
  camionesCalados: state.calado.dataCamionesCalados,
  camListosParaBruto: state.camionesIngreso.camListosParaBruto,
  calleDeBruto: selector(state, 'calleDeBruto'),
  cantidad: selector(state, 'cantidadPedido'),
  cea: state.pesado.consultaCeaBruto || {},
  cereal: selector(state, 'cerealPedido'),
  camionesPedidosBruto: state.pesado.camionesPedidosBruto,
  receiveCamListosParaBruto: state.camionesIngreso.receiveCamListosParaBruto,
  callesDeBruto: state.pesado.callesDeBruto,
  ocupacionBruto: selector(state, 'ocupacionBruto'),
  roles: state.auth.roles
})

const mapActionsToProps = {
  cargarPedidoDeBruto,
  getDataCamionesCalados,
  obtenerCallesDeBruto,
  setShowFooterPesado
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PEDIDO_EGRESO_CALADO,
  destroyOnUnmount: false,
  enableReinitialize: false,
  updateUnregisteredFields: true,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(PedidosEgresoCalado))
